import React, { useState, useEffect } from 'react';
import { suggestionService, authService } from '../services/api';
import { formatDate } from '../utils/dateFormats';

export default function Suggestions() {
  const [text, setText] = useState('');
  const [district, setDistrict] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const isAdmin = authService.isAuthenticated() && authService.getCurrentUser().role === 'admin';

  // Simularemos los distritos por ahora - idealmente deberían venir de la API
  const districts = [
    { id: "D1", name: "Distrito 1" },
    { id: "D2", name: "Distrito 2" },
    { id: "D3", name: "Distrito 3" },
    { id: "D4", name: "Distrito 4" }
  ];

  useEffect(() => {
    if (districts.length > 0) {
      setDistrict(districts[0].id);
    }
    loadSuggestions();
  }, []);

  const loadSuggestions = async () => {
    try {
      const response = isAdmin ? await suggestionService.getSuggestions() : await suggestionService.getMySuggestions();
      setSuggestions(response.data);
      setError(null);
    } catch (err) {
      console.error('Error loading suggestions:', err);
      setError('Error al cargar las sugerencias');
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!text || !district) return;

    if (!authService.isAuthenticated()) {
      setError('Debes iniciar sesión para enviar sugerencias');
      window.location.href = '/login';
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await suggestionService.createSuggestion({
        district,
        text
      });
      setText('');
      await loadSuggestions(); // Recargar las sugerencias después de crear una nueva
      alert('¡Gracias por tu sugerencia! Ha sido enviada correctamente.');
    } catch (err) {
      setError('Error al enviar la sugerencia. Por favor, intenta de nuevo.');
      console.error('Error submitting suggestion:', err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className='max-w-6xl mx-auto px-4 py-12'>
      <h3 className='text-lg font-semibold mb-3'>Panel de sugerencias ciudadanas</h3>
      {authService.isAuthenticated() ? (
        <form onSubmit={handleSubmit} className='grid grid-cols-1 md:grid-cols-3 gap-3'>
          <select value={district} onChange={e=>setDistrict(e.target.value)} className='p-2 border rounded'>
            {districts.map(d=> <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <input value={text} onChange={e=>setText(e.target.value)} placeholder='¿Qué necesita tu barrio?' className='p-2 border rounded md:col-span-2' />
          <div className='md:col-span-3 flex gap-3'>
            <button className='px-4 py-2 bg-[color:var(--primary)] text-white rounded'>Enviar</button>
            <div className='text-sm text-gray-600'>Tu sugerencia ayudará a generar un mapa de demandas.</div>
          </div>
        </form>
      ) : (
        <div className="text-center p-4 bg-gray-50 rounded-lg mb-6">
          <p className="text-gray-600">Para enviar una sugerencia necesitas iniciar sesión.</p>
          <Link to="/login" className="inline-block mt-2 px-4 py-2 bg-[color:var(--primary)] text-white rounded">
            Iniciar sesión
          </Link>
        </div>
      )}
      <div className='mt-4'>
        <h4 className='font-semibold'>{isAdmin ? "Sugerencias recientes" : "Mis sugerencias" }</h4>
        <ul className='mt-2 space-y-2'>
          {(suggestions||[]).slice().reverse().map(s=> (
            <li key={s.id} className='border rounded p-2'>
              <div className='text-sm text-gray-500'>{formatDate(s.createdAt)} · {districts.find(d=>d.id===s.district)?.name || s.district}</div>
              <div>{s.text}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}